import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_process_template_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    process_name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    machine_guid: fromDatatype.GuidDataFieldInterface;
    process_guid: fromDatatype.GuidDataFieldInterface;
    template_type: fromDatatype.VarcharDatatypeInterface;
    output_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    output_inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_type_code:  fromDatatype.VarcharDatatypeInterface;
    item_marking: fromDatatype.TextDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
};

export class bl_mrp_process_template_hdr_RowClass implements bl_mrp_process_template_hdr_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    process_name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    machine_guid: fromDatatype.GuidDataFieldInterface;
    process_guid: fromDatatype.GuidDataFieldInterface;
    template_type: fromDatatype.VarcharDatatypeInterface;
    output_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    output_inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    process_type_code:  fromDatatype.VarcharDatatypeInterface;
    item_marking: fromDatatype.TextDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
  }
